import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import App from "../App";

const primaryColor = '#5f3411';
// const secondaryColor = '#719848';

const theme = createTheme({
    palette: {
        primary: {
            main: '#8e571f',
        },
        secondary: {
            main: '#719848',
        },
    },
    typography: {
        fontFamily: 'Source Sans Pro, sans-serif',
        h3: {
            fontSize: '1.7em',
            fontWeight: 'bold',
            color: primaryColor,
        },
        h5: {
            color: '#000000',
            'font-size': '1.4em',
        }
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                // OJO: esto no carga la fuente. JSS espera objetos con las
                // propiedades del @font-face (fontFamily, src...), no una
                // cadena, y ademas la URL es la de una hoja de estilos, no la
                // de un fichero de fuente. Source Sans Pro se referencia en
                // App.scss e index.scss pero nada llega a descargarla, asi que
                // el navegador cae al sans-serif del sistema. Se conserva tal
                // cual; la forma correcta seria un <link> en index.html.
                '@font-face': ['src:url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,700&display=swap)'] as never,
            },
        },
    },

});


function Theming(): React.ReactElement {

    return (
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    );
}

export {
    theme,
    Theming,
}
